<template>
  <div class="admin-container">
    <!-- 登录界面 -->
    <div v-if="!isLoggedIn" class="login-panel">
      <h2>🛡️ 管理员登录</h2>
      <form @submit.prevent="handleLogin">
        <input v-model="email" type="email" placeholder="邮箱" required>
        <input v-model="password" type="password" placeholder="密码" required>
        <button type="submit" :disabled="loginLoading">
          {{ loginLoading ? '正在登录...' : '登 录' }}
        </button>
      </form>
      <div v-if="loginMessage" :class="['message', loginMessageType]">{{ loginMessage }}</div>
    </div>

    <!-- 后台界面 -->
    <div v-else class="admin-panel">
      <div class="header">
        <h2>🚀 用户管理</h2>
        <button @click="logout" class="logout-btn">退出</button>
      </div>
      <button @click="fetchUsers" class="refresh-btn">🔄 刷新数据</button>
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>用户</th>
            <th>邮箱</th>
            <th>积分</th>
            <th>角色</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user.id">
            <td>{{ user.id }}</td>
            <td>{{ user.username }}</td>
            <td>{{ user.email }}</td>
            <td>{{ user.drawing_points }}</td>
            <td>{{ user.role }}</td>
            <td>
              <button @click="addPoints(user.id)" class="action-btn">+10分</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import api from '../utils/api'
import { showSuccessToast, showErrorToast } from '../utils/toast'

export default {
  name: 'Admin',
  data() {
    return {
      isLoggedIn: false,
      email: '',
      password: '',
      loginLoading: false,
      loginMessage: '',
      loginMessageType: '',
      authToken: '',
      users: []
    }
  },
  mounted() {
    // 检查是否已登录
    const token = localStorage.getItem('token') || sessionStorage.getItem('token')
    if (token) {
      this.authToken = token
      this.checkAdminStatus()
    }
  },
  methods: {
    async handleLogin() {
      this.loginLoading = true
      this.loginMessage = ''
      
      try {
        const res = await api.post('/auth/login', {
          email: this.email,
          password: this.password
        })
        
        if (res.success) {
          this.authToken = res.data.token
          
          // 检查权限
          if (res.data.user.role !== 'admin') {
            this.loginMessage = '登录成功，但该账号不是管理员！'
            this.loginMessageType = 'error'
            this.loginLoading = false
            return
          }
          
          this.isLoggedIn = true
          this.loginMessage = ''
          this.fetchUsers()
        } else {
          this.loginMessage = '错误: ' + (res.error || '未知错误')
          this.loginMessageType = 'error'
        }
      } catch (error) {
        console.error(error)
        this.loginMessage = '网络请求失败: ' + error.message
        this.loginMessageType = 'error'
      } finally {
        this.loginLoading = false
      }
    },
    
    async checkAdminStatus() {
      try {
        const res = await api.get('/user')
        if (res && res.data && res.data.role === 'admin') {
          this.isLoggedIn = true
          this.fetchUsers()
        }
      } catch (error) {
        console.error('验证失败:', error)
      }
    },
    
    async fetchUsers() {
      try {
        const res = await api.get('/admin/users')
        if (res.success) {
          this.users = res.data
        } else {
          alert('加载失败: ' + res.error)
        }
      } catch (error) {
        alert('加载出错: ' + error.message)
      }
    },
    
    async addPoints(userId) {
      if (!confirm('确定加分吗？')) return
      
      try {
        const res = await api.post('/admin/users/points', {
          userId: userId,
          points: 10
        })
        
        if (res.success) {
          showSuccessToast('成功')
          this.fetchUsers()
        } else {
          showErrorToast('失败')
        }
      } catch (error) {
        showErrorToast('操作失败')
      }
    },
    
    logout() {
      this.isLoggedIn = false
      this.authToken = ''
      this.users = []
      this.email = ''
      this.password = ''
      this.loginMessage = ''
    }
  }
}
</script>

<style scoped>
.admin-container {
  font-family: sans-serif;
  background: #f3f4f6;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  margin: 0;
  padding: 20px;
}

.login-panel,
.admin-panel {
  width: 100%;
  max-width: 1000px;
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.admin-panel {
  text-align: left;
}

.login-panel h2,
.admin-panel h2 {
  margin-bottom: 20px;
}

.login-panel input {
  width: 100%;
  padding: 15px;
  margin: 10px 0;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
  box-sizing: border-box;
}

.login-panel button,
.logout-btn,
.refresh-btn {
  width: 100%;
  padding: 15px;
  background: #4f46e5;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  font-weight: bold;
  margin-top: 10px;
}

.login-panel button:hover,
.logout-btn:hover,
.refresh-btn:hover {
  background: #4338ca;
}

.login-panel button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.logout-btn,
.refresh-btn {
  width: auto;
  padding: 5px 15px;
  font-size: 14px;
  margin: 0;
}

.logout-btn {
  background: #ef4444;
}

.logout-btn:hover {
  background: #dc2626;
}

.refresh-btn {
  background: #10b981;
  margin-bottom: 10px;
}

.refresh-btn:hover {
  background: #059669;
}

.message {
  margin-top: 15px;
  font-size: 14px;
  min-height: 20px;
}

.message.error {
  color: red;
}

.message.success {
  color: green;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

th,
td {
  border: 1px solid #eee;
  padding: 12px;
  text-align: left;
}

th {
  background: #f9fafb;
}

.action-btn {
  width: auto;
  padding: 5px 10px;
  font-size: 12px;
  background: #10b981;
}

.action-btn:hover {
  background: #059669;
}
</style>


